/* Template: cancel apoinmnet link confermation
   ========================================================================== */

'use strict';

$('.appCancel').on('click',
	function() {
		return confirm('Are you sure?');
	});